const SUPPORT_FAQ_STOP_WORDS = new Set([
  'a',
  'an',
  'and',
  'are',
  'can',
  'do',
  'does',
  'for',
  'how',
  'i',
  'is',
  'me',
  'my',
  'of',
  'tell',
  'the',
  'to',
  'what',
  'with',
  'you',
  'your',
])

const normalizeText = (value = '') => value.toLowerCase().trim()

const tokenizeQuery = (query) => normalizeText(query)
  .split(/[^a-z0-9]+/)
  .filter((token) => token.length >= 3 && !SUPPORT_FAQ_STOP_WORDS.has(token))

/**
 * Find the single best FAQ match for a support query.
 *
 * The matcher ignores generic question words and scores exact subscription
 * keywords higher than broad platform text.
 */
export const findMatchingSupportFaq = (query, faqList) => {
  const normalizedQuery = normalizeText(query)
  const queryTokens = tokenizeQuery(query)

  if (!normalizedQuery || queryTokens.length === 0) {
    return null
  }

  const scoredMatches = faqList
    .map((faq, index) => {
      const question = normalizeText(faq.question)
      const answer = normalizeText(faq.answer)
      const category = normalizeText(faq.category)
      const keywords = Array.isArray(faq.keywords)
        ? faq.keywords.map((keyword) => normalizeText(keyword))
        : []

      let score = 0

      if (question.includes(normalizedQuery)) {
        score += 12
      }

      if (keywords.some((keyword) => keyword === normalizedQuery)) {
        score += 14
      }

      if (keywords.some((keyword) => keyword.includes(normalizedQuery) || normalizedQuery.includes(keyword))) {
        score += 8
      }

      queryTokens.forEach((token) => {
        if (question.includes(token)) {
          score += 5
        }
        if (keywords.some((keyword) => keyword.includes(token))) {
          score += 4
        }
        if (category.includes(token)) {
          score += 2
        }
        if (answer.includes(token)) {
          score += 1
        }
      })

      return { faq, score, index }
    })
    .filter((candidate) => candidate.score > 0)
    .sort((left, right) => {
      if (right.score !== left.score) {
        return right.score - left.score
      }
      return left.index - right.index
    })

  return scoredMatches[0]?.faq ?? null
}
